import React from "react";

import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Link} from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";



export default class Users extends CollectionOverride {
	constructor(props) {
		super(props, Types.Users._name);
		this.model.sort = 'enabled';
		this.model.order = 'desc';
		this.sort = 'enabled';
		this.order = 'desc';
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "First",
				id: "name_first",
				/** @param {Users_Object} obj */
				accessor: obj => obj.name_first,
			},
			{
				Header: "Last",
				id: "name_last",
				/** @param {Users_Object} obj */
				accessor: obj => obj.name_last,
			},
			{
				Header: "Email",
				id: "email",
				/** @param {Users_Object} obj */
				accessor: obj => obj.email,
			},
			{
				Header: "Location",
				id: "location",
				/** @param {Users_Object} obj */
				accessor: obj => (obj.location ? obj.locations.name_display || obj.locations.name : "All Locations")
			},
			{
				Header: "Access",
				id: "access",
				/** @param {Users_Object} obj */
				accessor: obj => obj.user_accesses.name,
			},
			{
				Header: "Status",
				id: "enabled",
				/** @param {Users_Object} obj */
				accessor: obj => obj.enabled ? 'Active' : 'Disabled',
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props => {
					if(props.original.pkey !== 0) {
						return (
							<span>
								<Link to={`/users/${props.original._id}`}>
									<Button color="green-meadow" size="sm" block={true}>
										<i className="fa fa-pencil"/>
									</Button>
								</Link>
							</span>
						);
					} else{
						return (
							<span></span>
						)
					}
				}
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Users', "")}
								{this.renderHeaderRight("Users", columns)}
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							defaultPageSize={limit}
							pageSize={limit}
							pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
